import { render, staticRenderFns } from "./EditProfileDialog.vue?vue&type=template&id=0988dcd4"
import script from "./EditProfileDialog.vue?vue&type=script&lang=ts"
export * from "./EditProfileDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports